import { useState } from 'react';


/*
modification of CardCollapsible
*/

const HelpWidget = (props) => {
  let initialOpened = false;
  if (props.initialOpened === true) {
    initialOpened = true;
  }
  const [opened, setOpened] = useState(initialOpened);
  const [rendering, setRendering] = useState(initialOpened);

  let _trouglic = (e) => {
    // console.log('klik na trouglic');
    if (opened) {
      setOpened(false);
    } else {
      setOpened(true);
      if (rendering !== true) {
        setRendering(true);
      }
    }
  }

  let alwaysOpened = false;
  if (props.alwaysOpened === true) {
    alwaysOpened = true;
  }

  let clOpened = ' help-widget--closed';
  if (opened || alwaysOpened) {
    clOpened = ' help-widget--opened opened';
  }


  // let inline = false;
  let clInline = false;
  if (props.inline === true) {
    clInline = ' help-widget--inline';
  }

  let extraClass = '';
  if (typeof props.extraClass === 'string' && props.extraClass !== '') {
    extraClass = ' ' + props.extraClass;
  }

  let tooltip = 'Prikaži pomoć';
  let title = 'Pomoć:';
  if (typeof props.tooltip === 'string' && props.tooltip !== '') {
    tooltip = props.tooltip;
  }
  if (typeof props.title === 'string' && props.title !== '') {
    title = props.title;
  }

  return (
    <div className={"help-widget" + clOpened + clInline + extraClass}>
      <div className="help-widget__header">
        <div className={"help-widget__btn"} onClick={_trouglic}>
          {
            opened ? (
              <abbr title="Zatvori pomoć">×</abbr>
            ) : (
              <abbr title={tooltip}><i className="fa fa-question" aria-hidden="true"></i></abbr>
            )
          }
        </div>
        {
          opened && (
            <span className="help-widget__title">{title}</span>
          )
        }
      </div>
      <div className="widget-card-colapsible__collapser">
        {
          opened === true && (props.children)
        }
      </div>
    </div>
  );
};

export default HelpWidget;